import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-dc1d789c")

_pushScopeId("data-v-dc1d789c")
const _hoisted_1 = {
  key: 0,
  class: "result-view"
}
const _hoisted_2 = { class: "view-header" }
const _hoisted_3 = {
  key: 0,
  class: "request-view view-card"
}
const _hoisted_4 = { class: "view-card__header" }
const _hoisted_5 = { class: "view-card__header__top" }
const _hoisted_6 = { class: "status" }
const _hoisted_7 = { class: "insertDate -notosans" }
const _hoisted_8 = {
  key: 0,
  class: "view-card__header__mid"
}
const _hoisted_9 = { class: "list-item-detail" }
const _hoisted_10 = {
  key: 0,
  class: "-medium"
}
const _hoisted_11 = { class: "label" }
const _hoisted_12 = { class: "value" }
const _hoisted_13 = {
  key: 1,
  class: "-medium"
}
const _hoisted_14 = { class: "label" }
const _hoisted_15 = { class: "value" }
const _hoisted_16 = { class: "-medium" }
const _hoisted_17 = { class: "label" }
const _hoisted_18 = { class: "value" }
const _hoisted_19 = {
  key: 2,
  class: "-medium"
}
const _hoisted_20 = { class: "label" }
const _hoisted_21 = { class: "value" }
const _hoisted_22 = {
  key: 3,
  class: "-medium -pc"
}
const _hoisted_23 = { class: "label" }
const _hoisted_24 = { class: "value" }
const _hoisted_25 = {
  key: 0,
  class: "-medium -mobile scheduled-date"
}
const _hoisted_26 = { class: "label" }
const _hoisted_27 = { class: "value -notosans" }
const _hoisted_28 = { class: "view-card__header__bot" }
const _hoisted_29 = /*#__PURE__*/_createVNode("div", { class: "-vector" }, null, -1)
const _hoisted_30 = { class: "view-card__body" }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { class: "label" }
const _hoisted_33 = { class: "value" }
const _hoisted_34 = { class: "label" }
const _hoisted_35 = { class: "value" }
const _hoisted_36 = { key: 1 }
const _hoisted_37 = { class: "label" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_RequestProgressDesc = _resolveComponent("RequestProgressDesc")
  const _component_RequestProgress = _resolveComponent("RequestProgress")
  const _component_DoctorItem = _resolveComponent("DoctorItem")
  const _component_router_link = _resolveComponent("router-link")
  const _component_FileList = _resolveComponent("FileList")

  return (!!_ctx.cardInfo && !!_ctx.state.requestView)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "title", {}, undefined, true),
          _createVNode(_component_RequestProgressDesc, {
            cardInfo: _ctx.cardInfo,
            class: "-mobile"
          }, null, 8, ["cardInfo"])
        ]),
        (!_ctx.state.isLoading && _ctx.state.requestView)
          ? (_openBlock(), _createBlock("div", _hoisted_3, [
              _createVNode("div", _hoisted_4, [
                _createVNode("div", _hoisted_5, [
                  _createVNode("div", _hoisted_6, [
                    _createVNode(_component_RequestProgress, { cardInfo: _ctx.cardInfo }, null, 8, ["cardInfo"]),
                    _createVNode(_component_RequestProgressDesc, {
                      cardInfo: _ctx.cardInfo,
                      class: "-pc"
                    }, null, 8, ["cardInfo"])
                  ]),
                  _createVNode("span", _hoisted_7, _toDisplayString(_ctx.insertDateTime), 1)
                ]),
                (!!_ctx.state.doctor)
                  ? (_openBlock(), _createBlock("div", _hoisted_8, [
                      _createVNode(_component_DoctorItem, {
                        doctor: _ctx.state.doctor,
                        isDefaultDetail: false
                      }, {
                        detail: _withId(() => [
                          _createVNode("div", _hoisted_9, [
                            _createVNode("ul", null, [
                              (
                      _ctx.state.requestView.RequestType !== 1 &&
                        _ctx.state.requestView.DoctorName &&
                        _ctx.state.requestView.DeptName
                    )
                                ? (_openBlock(), _createBlock("li", _hoisted_10, [
                                    _createVNode("span", _hoisted_11, _toDisplayString(_ctx.state.requestView.FacilityName) + " " + _toDisplayString(_ctx.state.requestView.DeptName), 1),
                                    _createVNode("span", _hoisted_12, _toDisplayString(_ctx.state.requestView.DoctorName), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.hasHospitalNameAndDept)
                                ? (_openBlock(), _createBlock("li", _hoisted_13, [
                                    _createVNode("span", _hoisted_14, _toDisplayString(_ctx.t("hospital & dept")), 1),
                                    _createVNode("span", _hoisted_15, _toDisplayString(_ctx.hospitalNameAndDeptName), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              _createVNode("li", _hoisted_16, [
                                _createVNode("span", _hoisted_17, _toDisplayString(_ctx.t("request kind")), 1),
                                _createVNode("span", _hoisted_18, _toDisplayString(_ctx.requestKind), 1)
                              ]),
                              (_ctx.state.requestView.RequestKind === _ctx.RequestKindTypes.OnlineCare)
                                ? (_openBlock(), _createBlock("li", _hoisted_19, [
                                    _createVNode("span", _hoisted_20, _toDisplayString(_ctx.t("appointment type")), 1),
                                    _createVNode("span", _hoisted_21, _toDisplayString(_ctx.appointmentType), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.state.requestView.RequestKind === _ctx.RequestKindTypes.OnlineCare)
                                ? (_openBlock(), _createBlock("li", _hoisted_22, [
                                    _createVNode("span", _hoisted_23, _toDisplayString(_ctx.state.requestView.RequestStatus === _ctx.RequestStatuses.Requested
                        ? _ctx.t("desired date/time")
                        : _ctx.t("reserved date/time")), 1),
                                    _createVNode("span", _hoisted_24, _toDisplayString(_ctx.scheduledDate), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]),
                        _: 1
                      }, 8, ["doctor"]),
                      (
              _ctx.state.requestView.RequestType !== 1 &&
                _ctx.state.requestView.RequestKind === _ctx.RequestKindTypes.OnlineCare
            )
                        ? (_openBlock(), _createBlock("div", _hoisted_25, [
                            _createVNode("div", null, [
                              _createVNode("span", _hoisted_26, _toDisplayString(_ctx.state.requestView.RequestStatus === _ctx.RequestStatuses.Requested
                  ? _ctx.t("desired date/time")
                  : _ctx.t("reserved date/time")), 1),
                              _createVNode("span", _hoisted_27, _toDisplayString(_ctx.scheduledDate), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_28, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.cardInfo.buttons, (b, index) => {
                    return (_openBlock(), _createBlock(_Fragment, { key: index }, [
                      (b.type === 'link')
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            class: ["-button", b.style],
                            to: !!b.path ? b.path() : ''
                          }, {
                            default: _withId(() => [
                              _createTextVNode(_toDisplayString(b.label), 1)
                            ]),
                            _: 2
                          }, 1032, ["to", "class"]))
                        : _createCommentVNode("", true),
                      (b.type === 'button')
                        ? (_openBlock(), _createBlock("button", {
                            key: 1,
                            class: ["-button", b.style],
                            onClick: b.func
                          }, _toDisplayString(b.label), 11, ["onClick"]))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ])
              ]),
              _hoisted_29,
              _createVNode("div", _hoisted_30, [
                _createVNode("ul", null, [
                  (
              !!_ctx.state.requestView.OtherComments &&
                _ctx.state.requestView.RequestStatus > _ctx.RequestStatuses.Requested
            )
                    ? (_openBlock(), _createBlock("li", _hoisted_31, [
                        _createVNode("span", _hoisted_32, _toDisplayString(_ctx.t("request comments")), 1),
                        _createVNode("span", _hoisted_33, _toDisplayString(_ctx.state.requestView.OtherComments), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("li", null, [
                    _createVNode("span", _hoisted_34, _toDisplayString(_ctx.t("chief complaint")), 1),
                    _createVNode("span", _hoisted_35, _toDisplayString(_ctx.state.requestView.PurposeOthers), 1)
                  ]),
                  (!!_ctx.state.files)
                    ? (_openBlock(), _createBlock("li", _hoisted_36, [
                        _createVNode("span", _hoisted_37, _toDisplayString(_ctx.t("attached files")), 1),
                        (_ctx.state.files && _ctx.state.files.length > 0)
                          ? (_openBlock(), _createBlock(_component_FileList, {
                              key: 0,
                              class: "upload-files",
                              list: _ctx.state.files,
                              onDeletedFile: _ctx.deletedFile,
                              id: _ctx.state.id,
                              requestKind: _ctx.state.requestView.RequestKind
                            }, null, 8, ["list", "onDeletedFile", "id", "requestKind"]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
})